/* eslint-disable no-param-reassign */
import Vue from "vue";
import { NewsItem } from "./types.d";

const setNewsItems = (state, newsItems: NewsItem[]) => {
  state.newsItems = [...newsItems];
};

const mergeNewsItems = (state, newsItems: NewsItem[]) => {
  const curItems = state.newsItems;
  newsItems = newsItems.filter(item => {
    let present = false;
    const { length } = curItems;
    for (let index = length - 1; index >= 0; index -= 1) {
      const it = curItems[index];
      if (
        it.guid === item.guid &&
        it.versionCreated.toISOString() === item.versionCreated.toISOString()
      ) {
        present = true;
        break;
      } else if (it.guid === item.guid) {
        // The item has a different timestamp and needs updating
        state.newsItems.splice(index, 1);
        break;
      }
    }
    console.log(`Present is ${present}`);
    return !present;
  });
  console.log(`Adding ${newsItems.length} from polling items`);

  newsItems.map(i => (i.addedAt = new Date()));

  state.newsItems = [...newsItems, ...curItems];
};

const mergeLoadMoreNewsItems = (state, newsItems: NewsItem[]) => {
  const curItems = state.newsItems;
  state.newsItems = [...curItems, ...newsItems];
};

const mergeRemoteContent = (state, remoteContents: { IRemoteContent }) => {
  const curItems = state.remoteContent;
  state.remoteContents = { ...curItems, ...remoteContents };
};

const addNewsItem = (state, newsItem: NewsItem) => {
  const { newsItems } = state;
  state.newsItems = [...newsItems, newsItem];
};

const setIsLoading = (state, isLoading: boolean) => {
  state.isLoading = isLoading;
};

const updateNewsItem = ({ newsItems }, { index, newsItem }) => {
  newsItems.splice(index, 1, newsItem);
};

// validate if being reactive
const setRemoteContent = (state, objects) => {
  state.remoteContent = { ...objects };
};

const setEncodedImage = ({ encodedImages }, { key, data, guid }) => {
  const encodedImage = {
    ...encodedImages[guid],
    [key]: data
  };
  Vue.set(encodedImages, guid, encodedImage);
};

const setTotalResults = (state, totalResults) => {
  state.totalResults = totalResults;
};

const setSearchContinuationFields = (state, searchContinuationFields) => {
  state.searchContinuationFields = searchContinuationFields;
};

// don't think it's being reactive.
// indexed objects are much easier to use in this case
// but need to make sure the app reacts to changes to this object
const addData = (state, { data, residref }) => {
  if (state.remoteContent[residref]) {
    const temp = {
      ...state.remoteContent
    };
    temp[residref].data = data;
    state.remoteContent = temp;
  }
};

const setSearchTimeStamp = (state, searchTimeStamp) => {
  state.searchTimeStamp = searchTimeStamp;
};

export default {
  setNewsItems,
  addNewsItem,
  setIsLoading,
  updateNewsItem,
  setRemoteContent,
  addData,
  mergeNewsItems,
  mergeLoadMoreNewsItems,
  mergeRemoteContent,
  setEncodedImage,
  setTotalResults,
  setSearchContinuationFields,
  setSearchTimeStamp
};
